import React from 'react'
import { Link } from 'react-router-dom'
import abImg1 from '../../images/about/img-1.jpg'
import abImg2 from '../../images/about/img-2.jpg'



const About = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="wpo-about-section section-padding">
            <div className="container">
                <div className="wpo-about-wrap">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12 col-12">
                            <div className="wpo-about-img">
                                <div className="wpo-about-left">
                                    <img src={abImg2} alt="img" />
                                </div>
                                <div className="wpo-about-right">
                                    <img src={abImg1} alt="img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-12">
                            <div className="wpo-about-text">
                                <div className="wpo-section-title">
                                    <span>Welcome to Heart-to-Heart Children Aid</span>
                                    <h2>Your Support Saves a Child's Heart</h2>
                                </div>
                                <p>Heart-to-Heart Children Aid was founded out of a deep belief that every heartbeat matters. We are a committed humanitarian organization providing free heart surgeries for children who cannot afford life-saving care. Our journey began in Ethiopia, where our founder, Ato Birhan Tedla, personally sponsored over 80 children's surgeries, covering over $200K million in medical costs. Today, we work from Washington, D.C., and Addis Ababa to reach children across the world. Join our mission to give children the opportunity to live, learn, and play, as we strive to save 1000 lives every year.</p>

                                {/* <div className="about-info-wrap">
                                    <div className="about-info-item">
                                        <div className="about-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-target"></i>
                                            </div>
                                        </div>
                                        <div className="about-info-text">
                                            <h4>Our Mission</h4>
                                            <p>Investing in life-saving surgery guarantees a child's future</p>
                                        </div>
                                    </div>
                                    <div className="about-info-item">
                                        <div className="about-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-mountain"></i>
                                            </div>
                                        </div>
                                        <div className="about-info-text">
                                            <h4>Our Vision</h4>
                                            <p>A world where every heart beats strong</p>
                                        </div>
                                    </div>
                                </div> */}

                                <Link onClick={ClickHandler} to="/about" className="theme-btn">Discover More</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;

